import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {
  FetchGroupDashboardParticipantBehaviorPhysicalActivityModel,
  FetchGroupDashboardParticipantBehaviorRedLightsModel,
  FetchGroupDashboardParticipantBehaviorScreenTimeModel,
  FetchGroupDashboardParticipantInformationModel,
  FetchGroupDashboardParticipantWeightModel,
} from '../models/fetch-groups-dashboard.model';
import {
  FetchParticipantsAndCaregiversListModel
} from '../../clients-list/model/fetch-participants-and-caregivers-list.model';
import {v1URL} from '../../../shared/constants/urls.constants';
import {
  FetchGroupFilterModel
} from '../../clients-list/model/fetch-group-filter.model';
import {
  FetchUserStatusFilterModel
} from '../../clients-list/model/fetch-user-status-filter.model';
import {CommonService} from '../../../shared/services/common.service';
import {
  FetchDashboardFilterModel
} from '../../clients-list/model/fetch-dashboard-filter.model';
import {
  FetchGroupsTypeFilterModel
} from '../../coach-groups-list/models/fetch-groups-type-filter.model';
import {
  FetchParticipantsWeightListModel
} from '../../clients-list/model/fetch-participants-weight-list.model';
import {
  FetchParticipantsBehaviourListModel
} from "../../clients-list/model/fetch-participants-behaviour-list.model";

@Injectable({
  providedIn: 'root',
})
export class GroupDashboardService {
  constructor(
    private commonServices: CommonService,
  ) {
  }

  fetchGroupDashboardParticipantInformationData(): Observable<
    FetchGroupDashboardParticipantInformationModel['response']
  > {
    return of({
      success: true,
      code: 'Dummy Code  ABCD1234',
      message:
        'Group Dashboard Participant Information Data Fetched Successfully',
      data: {
        participantInformation: [
          {
            id: 20,
            fullName: 'Wayne Alvarado',
            status: 'Active',
            gender: 'Male',
            ageAtStart: 11,
            age: 12,
            mostRecentSessionAttended: 'Session 4',
            totalAttendance: 100,
            role: 4
          },
          {
            id: 2,
            fullName: 'Wayne Alvarado',
            status: 'Inactive',
            gender: 'Male',
            ageAtStart: 31,
            age: 32,
            mostRecentSessionAttended: 'Session 4',
            totalAttendance: 100,
            role: 3
          },
          {
            id: 3,
            fullName: 'Wayne Alvarado',
            status: 'Inactive',
            gender: 'Male',
            ageAtStart: 11,
            mostRecentSessionAttended: 'Session 4',
            totalAttendance: 100,
          },
          {
            id: 4,
            fullName: 'Wayne Alvarado',
            status: 'Active',
            gender: 'Male',
            ageAtStart: 11,
            mostRecentSessionAttended: 'Session 4',
            totalAttendance: 100,
          },
        ],
        average: {
          maleToFemaleRatio: '6/1',
          averageAge: 11,
          lastSession: 4,
          averageAttendance: 96
        }
      },
    });
  }

  fetchGroupDashboardParticipantWeightData(): Observable<
    FetchGroupDashboardParticipantWeightModel['response']
  > {
    return of({
      success: true,
      code: 'Dummy Code  ABCD1234',
      message: 'Group Dashboard Participant Weight Data Fetched Successfully',
      data: {
        participantWeight: [
          {
            participantName: "Wayne Alvarado",
            currentWeight: 42,
            weightChangeSinceBaseLine: 42,
            weightLossAlert: false,
            currentBMI: 42,
            changeBMI: 42,
            medianBMI: 42,
            overallBMIChange: 42,
            changeOverIle: 42,
            overIle: 40
          },
          {
            participantName: "Wayne Alvarado",
            currentWeight: 42,
            weightChangeSinceBaseLine: 42,
            weightLossAlert: false,
            currentBMI: 42,
            changeBMI: 42,
            medianBMI: 42,
            overallBMIChange: 42,
            changeOverIle: 42,
            overIle: 40
          },
          {
            participantName: "Wayne Alvarado",
            currentWeight: 42,
            weightChangeSinceBaseLine: 42,
            weightLossAlert: false,
            currentBMI: 42,
            changeBMI: 42,
            medianBMI: 42,
            overallBMIChange: 42,
            changeOverIle: 42,
            overIle: 40
          },
          {
            participantName: "Wayne Alvarado",
            currentWeight: 42,
            weightChangeSinceBaseLine: 42,
            weightLossAlert: false,
            currentBMI: 42,
            changeBMI: 42,
            medianBMI: 42,
            overallBMIChange: 42,
            changeOverIle: 42,
            overIle: 40
          },
        ],
        average: {
          currentWeight: 42,
          weightChangeSinceBaseLine: 42,
          weightLossAlert: false,
          currentBMI: 42,
          changeBMI: 42,
          medianBMI: 42,
          overallBMIChange: 42,
          changeOverIle: 42,
          overIle: 40
        }
      },
    });
  }

  fetchGroupDashboardParticipantBehaviorRedLightsData(): Observable<
    FetchGroupDashboardParticipantBehaviorRedLightsModel['response']
  > {
    return of({
      success: true,
      code: 'Dummy Code  ABCD1234',
      message:
        'Group Dashboard Participant Behavior Red Lights Fetched Successfully',
      data: {
        participantBehaviorRedLights: [
          {
            participantName: 'Wayne Alvarado',
            numberOfDaysJournaledLastWeek: 7,
            readLightsGoalForLastWeek: 100,
            redLightsLastWeek: 95,
            overallDaysJournaled: 28,
            numberOfDaysRedLightsGoalsSet: 4,
            numberOfRedLightsGoalsMet: 3,
          },
          {
            participantName: 'Wayne Alvarado',
            numberOfDaysJournaledLastWeek: 7,
            readLightsGoalForLastWeek: 100,
            redLightsLastWeek: 95,
            overallDaysJournaled: 28,
            numberOfDaysRedLightsGoalsSet: 4,
            numberOfRedLightsGoalsMet: 3,
          },
          {
            participantName: 'Wayne Alvarado',
            numberOfDaysJournaledLastWeek: 7,
            readLightsGoalForLastWeek: 100,
            redLightsLastWeek: 95,
            overallDaysJournaled: 28,
            numberOfDaysRedLightsGoalsSet: 4,
            numberOfRedLightsGoalsMet: 3,
          },
        ],
        average: {
          numberOfDaysJournaledLastWeek: 7,
          readLightsGoalForLastWeek: 100,
          redLightsLastWeek: 95,
          overallDaysJournaled: 28,
          numberOfDaysRedLightsGoalsSet: 4,
          numberOfRedLightsGoalsMet: 3,
        }
      }
    });
  }

  fetchGroupDashboardParticipantBehaviorPhysicalActivityData(): Observable<
    FetchGroupDashboardParticipantBehaviorPhysicalActivityModel['response']
  > {
    return of({
      success: true,
      code: 'Dummy Code  ABCD1234',
      message:
        'Group Dashboard Participant Behavior Physical Activity Fetched Successfully',
      data: {
        participantBehaviorPhysicalActivity: [
          {
            participantName: 'Wayne Alvarado',
            numberOfDaysJournaledLastWeek: 7,
            physicalActivityGoalForLastWeek: '4000 / 4 Days',
            physicalActivityGoalAchievedForLastWeek: '3 Days',
            overallDaysJournaled: 28,
            numberOfDaysPhysicalActivityGoalsSet: 4,
            numberOfPhysicalActivityGoalsMet: 3,
          },
          {
            participantName: 'Wayne Alvarado',
            numberOfDaysJournaledLastWeek: 7,
            physicalActivityGoalForLastWeek: '4000 / 4 Days',
            physicalActivityGoalAchievedForLastWeek: '3 Days',
            overallDaysJournaled: 28,
            numberOfDaysPhysicalActivityGoalsSet: 4,
            numberOfPhysicalActivityGoalsMet: 3,
          },
          {
            participantName: 'Wayne Alvarado',
            numberOfDaysJournaledLastWeek: 7,
            physicalActivityGoalForLastWeek: '4000 / 4 Days',
            physicalActivityGoalAchievedForLastWeek: '3 Days',
            overallDaysJournaled: 28,
            numberOfDaysPhysicalActivityGoalsSet: 4,
            numberOfPhysicalActivityGoalsMet: 3,
          },
        ],
        average: {
          numberOfDaysJournaledLastWeek: 7,
          physicalActivityGoalForLastWeek: '4000 / 4 Days',
          physicalActivityGoalAchievedForLastWeek: '3 Days',
          overallDaysJournaled: 28,
          numberOfDaysPhysicalActivityGoalsSet: 4,
          numberOfPhysicalActivityGoalsMet: 3,
        }
      }
    });
  }

  fetchGroupDashboardParticipantBehaviorScreenTimeData(): Observable<
    FetchGroupDashboardParticipantBehaviorScreenTimeModel['response']
  > {
    return of({
      success: true,
      code: 'Dummy Code  ABCD1234',
      message:
        'Group Dashboard Participant Behavior Screen Time Data Fetched Successfully',
      data: {
        participantBehaviorScreenTime: [
          {
            participantName: 'Wayne Alvarado',
            numberOfDaysJournaledLastWeek: 7,
            screenTimeGoalForLastWeek: '1080 Minutes',
            screenTimeGoalAchievedForLastWeek: '1080 Minutes',
            overallDaysJournaled: 0,
            numberOfScreenTimeGoalsSet: 0,
            numberOfScreenTimeGoalsMet: 0,
          },
        ],
        average: {
          numberOfDaysJournaledLastWeek: 7,
          screenTimeGoalForLastWeek: '1080 Minutes',
          screenTimeGoalAchievedForLastWeek: '1080 Minutes',
          overallDaysJournaled: 0,
          numberOfScreenTimeGoalsSet: 0,
          numberOfScreenTimeGoalsMet: 0,
        }
      },
    });
  }

  fetchDashboardFilter(): Observable<FetchDashboardFilterModel['response']> {
    return of({
      success: true,
      code: 'Dummy Code ABCD1234',
      message: 'Dummy Message',
      data: {
        list: [
          {
            key: 1,
            value: 'Participant/Adult Information'
          },
          {
            key: 2,
            value: 'Participant Weight'
          },
          {
            key: 3,
            value: 'Participant Behavior'
          }
        ],
        total: null,
        pageNumber: 1,
        limit: 10,
        hasNext: false,
        hasPrev: false,
        loading: false
      }
    })
  }

  fetchParticipantsAndCaregiversList(payload: FetchParticipantsAndCaregiversListModel['request']): Observable<FetchParticipantsAndCaregiversListModel['response']> {
    const urlConfig = v1URL.dashboard.participantCaregiver
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchGroupListFilter(payload: FetchGroupFilterModel['request']): Observable<FetchGroupFilterModel['response']> {
    const urlConfig = v1URL.filters.groups
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchUserStatusListFilter(): Observable<FetchUserStatusFilterModel['response']> {
    const urlConfig = v1URL.filters['user-status']
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchGroupsTypeFilter(): Observable<FetchGroupsTypeFilterModel['response']> {
    const urlConfig = v1URL.filters.groupLocation
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchParticipantsWeightList(payload: FetchParticipantsWeightListModel['request']): Observable<FetchParticipantsWeightListModel['response']> {
    const urlConfig = v1URL.dashboard.participantWeightInformation
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchParticipantsBehaviourList(payload: FetchParticipantsBehaviourListModel['request']): Observable<FetchParticipantsBehaviourListModel['response']> {
    const urlConfig = v1URL.dashboard.participantBehaviourInformation
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }
}
